const SavedTabViews = self => ({
    get listNameBySelectedList() {
        var _a;
        return (_a = self.allLists.find(list => list.listKey === self.selectedList)) === null || _a === void 0 ? void 0 : _a.name;
    },
    get userTablesCount() {
        return self.allLists.filter(list => list.listKey !== 'all' && list.name !== 'All Contacts' && list.name !== 'All Companies').length;
    },
    get pipelineUserTables() {
        return self.pipelineTables
            .filter(list => list.listKey !== 'all' && list.name !== 'All Contacts' && list.name !== 'All Companies')
            .slice()
            .sort((a, b) => {
            const aTime = a.updatedAt ? new Date(a.updatedAt).getTime() : 0;
            const bTime = b.updatedAt ? new Date(b.updatedAt).getTime() : 0;
            return bTime - aTime;
        });
    },
});
export default SavedTabViews;
